import * as constants from './constants';

export const reset = () => ({type: constants.REGISTER_USER_RESET});

export const set = payload => ({type: constants.REGISTER_USER_SET, payload});

export const error = error => ({type: constants.REGISTER_USER_ERROR, error});